/* eslint-disable react/display-name */

import React, { FC, useCallback, useMemo } from "react";

import BaseDataGrid from "../../../../../components/modules/BaseDataGrid";
import Switch from "../../../../../components/elements/Switch";
import { BrandgenListDomain } from "../../../../../types/campaignTypes";

type DomainListProps = {
  isDisabled: boolean;
  domainsInList: BrandgenListDomain[];
  toggleSelectDomain: (domainId: string) => void;
  selectedDomainIds: string[];
};

const DomainList: FC<DomainListProps> = ({ isDisabled, domainsInList, toggleSelectDomain, selectedDomainIds }) => {
  const handleDomainInListStatusChange = useCallback(
    (row: any) => () => {
      toggleSelectDomain(row.id);
    },
    [toggleSelectDomain],
  );

  const rows = useMemo(
    () =>
      domainsInList.map((domainInList: BrandgenListDomain) => ({
        id: domainInList.id,
        domain: domainInList.name,
      })),
    [domainsInList],
  );

  const columns = useMemo(
    () => [
      { field: "domain", headerName: "Domain", flex: 2, disableColumnMenu: true },

      {
        field: "include",
        headerName: "Include",
        flex: 1,
        sortable: false,
        renderCell: (params: any) => (
          <Switch
            disabled={!isDisabled}
            checked={selectedDomainIds.includes(params.row.id)}
            onChange={handleDomainInListStatusChange(params.row)}
          />
        ),
      },
    ],
    [isDisabled, selectedDomainIds, handleDomainInListStatusChange],
  );

  return <BaseDataGrid columns={columns} rows={rows} autoHeight disableSelectionOnClick />;
};

export default DomainList;
